import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { AnyObjectSchema } from 'yup';
import { schedulerToolbarFormSchema } from './scheduler-toolbar-form.schema';
import { Schedule } from '../scheduler-field.context';

export const useSchedulerToolbarForm = (
  schedules?: Schedule[],
  additionalDataSchema?: AnyObjectSchema,
  timeFormat?: string,
  schema?: typeof schedulerToolbarFormSchema,
) => {
  const theSchema =
    schema?.(schedules, additionalDataSchema, timeFormat) ??
    schedulerToolbarFormSchema(schedules, additionalDataSchema, timeFormat);

  return useForm({
    resolver: yupResolver(theSchema),
    defaultValues: theSchema.cast({}),
    reValidateMode: 'onChange',
  });
};
